// Декоративный слой под фоновый PNG-узор.
// Положите узор в /public (например /decor/pattern.png) и передайте src,
// либо оставьте пустым — слой просто зарезервирует место под будущий паттерн.
//
// Идеи узоров под климатическую тему:
//  • blueprint-схема воздуховодов / вентиляции (тонкие линии)
//  • крупная пfолупрозрачная снежинка / вентилятор / «поток воздуха» в углу
//  • инженерная сетка (grid) или изолинии
export default function DecorLayer({
  src,
  pattern, // готовая CSS background-image строка (например, gearsPattern)
  opacity = 0.06,
  size = "cover",
  position = "center",
  repeat = "no-repeat",
  fade = false, // плавно растворять узор к краям (скрывает обрезку на стыках плиток)
  style,
}) {
  // Маска-затухание: узор виден в центре, прозрачен к краям — швы и обрезанные
  // у границ элементы не видны.
  const mask = fade
    ? "radial-gradient(ellipse 80% 75% at 50% 50%, #000 35%, transparent 100%)"
    : undefined;

  return (
    <div
      aria-hidden
      style={{
        position: "absolute",
        inset: 0,
        zIndex: 0,
        pointerEvents: "none",
        opacity,
        backgroundImage: pattern || (src ? `url('${src}')` : undefined),
        backgroundSize: size,
        backgroundPosition: position,
        backgroundRepeat: repeat,
        WebkitMaskImage: mask,
        maskImage: mask,
        ...style,
      }}
    />
  );
}
